import { styled } from '@mui/styles';
import { Card, CardProps } from '@mui/material';

export const CampaignCard = styled((props: CardProps) => <Card variant="outlined" {...props} />)(() => ({
    '& .MuiCardHeader-root': {
        paddingLeft: 24,
        paddingTop: 24,
        paddingBottom: 0,
    },
    '& .MuiCardContent-root': {
        paddingLeft: 24,
        paddingRight: 24,
    },
}));
